/*
  pdp-view-more.js
  ────────────────
  Mobile Om produktet / Specifikationer: content renders inline, clamped
  with a fade, and a "+ Vis mere" link expands it in place (Figma
  ShowMoreLink). Sections that fit inside the clamp get no link.
*/
(function () {
  if (window.__ggmPdpViewMore) return;
  window.__ggmPdpViewMore = true;

  var mq = window.matchMedia('(max-width: 1024px)');
  var CLAMP = 360;

  // Critical accordion CSS injected from here so JS and styles can never
  // be cache-skewed against each other (Rita #68 kept "not working"
  // because the phone served fresh JS with a stale stylesheet).
  var style = document.createElement('style');
  style.textContent = [
    '@media (max-width: 1024px) {',
    '  #product-info .Dropdown .Dropdown--Content {',
    '    display: block !important; height: auto !important; visibility: visible !important;',
    '  }',
    '  #product-info .Dropdown.pdp-acc-closed .Dropdown--Content,',
    '  #product-info .Dropdown.pdp-acc-closed .pdp-view-more { display: none !important; }',
    '  #product-info .Dropdown .pdp-accordion-chevron {',
    '    display: flex; align-items: center; flex-shrink: 0;',
    '    transition: transform 0.25s ease; transform: rotate(180deg) !important;',
    '  }',
    '  #product-info .Dropdown.pdp-acc-closed .pdp-accordion-chevron { transform: rotate(0deg) !important; }',
    '  #product-info .Dropdown .pdp-accordion-chevron svg {',
    '    width: 24px !important; height: 24px !important; margin: 0 !important;',
    '    transform: none !important; color: #282d34;',
    '  }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  function init() {
    if (!mq.matches) return;

    // Rita #68: mobile sections are inline accordions. The theme's own
    // machinery is unreliable here (DesktopProductInfo rewrites the
    // buttons for a modal that doesn't exist, and the dropdown
    // animation can wedge), so on mobile we own the toggle completely:
    // plain class flip, CSS does the showing/hiding.
    document
      .querySelectorAll('#product-info .Dropdown .custom__faq-dropdown-button')
      .forEach(function (btn) {
        if (btn.dataset.pdpAccordion) return;
        btn.dataset.pdpAccordion = '1';
        var dropdown = btn.closest('.Dropdown');
        var open = btn.getAttribute('aria-expanded') === 'true';
        dropdown.classList.toggle('pdp-acc-closed', !open);
      });

    var contents = document.querySelectorAll('#product-info .Dropdown--Content');
    Array.prototype.forEach.call(contents, function (content) {
      if (content.dataset.viewMore) return;
      content.dataset.viewMore = '1';
      content.classList.add('pdp-clamp');

      if (content.scrollHeight <= CLAMP + 40) {
        content.classList.add('is-expanded');
        return;
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdp-view-more';
      btn.textContent = '+  Vis mer';
      btn.addEventListener('click', function () {
        var expanded = content.classList.toggle('is-expanded');
        btn.textContent = expanded ? '−  Vis mindre' : '+  Vis mer';
      });
      content.parentNode.insertBefore(btn, content.nextSibling);
    });
  }

  // The theme's Delegate library binds ALL its handlers in CAPTURE phase
  // on ancestor elements, so they fire before any listener on the button
  // itself — the legacy open-modal handler was eating the tap. Bind on
  // document in capture phase: the first stop on every event path.
  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var btn = e.target && e.target.closest && e.target.closest('#product-info .custom__faq-dropdown-button');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    var dropdown = btn.closest('.Dropdown');
    if (!dropdown) return;
    var closed = dropdown.classList.toggle('pdp-acc-closed');
    btn.setAttribute('aria-expanded', closed ? 'false' : 'true');
    var content = dropdown.querySelector('.Dropdown--Content');
    if (content) content.setAttribute('aria-hidden', closed ? 'true' : 'false');
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', init);
  } else if (mq.addListener) {
    mq.addListener(init);
  }
})();
